import React from 'react';
import { Form, Checkbox, Label } from 'semantic-ui-react';

interface Props {
    input: {
        onChange: Function;
        value: boolean;
    };
    meta: {
        touched?: boolean;
        error?: string;
    };
    fluid?: boolean;
}

export default class RenderCheckbox extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            input: { value, onChange, ...input },
            meta: { touched, error },
            fluid,
            ...props
        } = this.props;

        return (
            <Form.Field error={!!(touched && error)}>
                <Checkbox
                    {...input}
                    {...props}
                    defaultChecked={!!value}
                    onChange={(event: any, data: any): void => {
                        onChange(data.checked);
                    }}
                    style={
                        fluid && {
                            display: 'block'
                        }
                    }
                />
                {!!(touched && error) && (
                    <Label basic color="red" pointing fluid>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}
